<template>
  <b-table 
    striped hover
    responsive
    small 
    outlined
    
    :items="items" 
    :fields="fields"
    :sticky-header="maxWidth(windowWidth)"

    :current-page="currentPage"
    :per-page="perPage"

    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    >
    <template v-slot:cell(Contador)="row">
      {{thousands_separators(row.item.Contador)}}
    </template>
    <template v-slot:cell(CantidadPlanificada)="row">
      {{thousands_separators(row.item.CantidadPlanificada)}}
    </template>
    <template v-slot:cell(CantidadFinalPT)="row">
      {{thousands_separators(row.item.CantidadFinalPT)}}
    </template>
  </b-table>
</template>

<script>
  import customMixin from '@/mixins/customMixin'
  export default {
    components:{},  
    mixins : [customMixin],
    props:{
      items:{
        type: Array,
        required: true
      },
      fields:{
        type: Array,
        required:true
      },
      currentPage:{
        type: Number,
        required: true
      },
      perPage:{
        type: Number,
        required: true
      },
      sortBy:{
        type: String,
        required:true
      },
      sortDesc:{
        type: Boolean,
        required:true
      }
    },
    data:function(){
      return{
        
      }
    },
    computed:{},
    mounted(){},
    methods:{},
        
  }
</script>

<style lang="scss" scoped>

</style>